module.exports = __webpack_public_path__ + "media/Aluna’s Theme (Afterwar ver).f2df6b31.mp3";